<template>
  <footer class="app-footer">
    <span><a href="http://wwww.dinamo.srv.br">Dinamo Engenharia </a> &copy; 2018 todos os direitos reservados</span>
    <span class="ml-auto">Desenvolvido por <a href="http://sistemas.dinamo.srv.br">DinTech - dreamWork </a> <strong> | {{version}}</strong></span>
  </footer>
</template>
<script>
export default {
  name: 'footer',
  computed:{
    version ()
    {
      return window.VERSION
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue